import { drawerClasses } from "@mui/material"
import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles()(() => ({
  paperDrawer: {
    [`&.${drawerClasses.paperAnchorRight}`]: {
      minWidth: "320px",
      width: "inherit"
    }
  }
}))
